import { Navigate, RouteObject } from 'react-router';

import { NotFoundChildRoute } from 'src/app/NotFoundChildRoute';

import AdminScreen from './AdminScreen';

export const adminRoutes: RouteObject[] = [
  {
    index: true,
    element: <Navigate to="mtm" />,
  },
  {
    path: 'momentm',
    element: <AdminScreen />,
  },
  {
    path: 'mtm',
    element: <AdminScreen />,
  },
  {
    path: '*',
    element: (
      <NotFoundChildRoute routePath="/admin" linkText="Go back to admin" />
    ),
  },
];
